import { Directive, ElementRef, Renderer2, HostListener, Input, OnInit } from '@angular/core';
import {ProductsService} from '../services/products.service';

@Directive({selector: '[appIngrdradio]'})
export class IngrdradioDirective {

  isChecked:string;
  ingridentArray:any[] = [];
  constructor(private renderer:Renderer2, private el:ElementRef, private prodObj:ProductsService) {}
  ngOnInit(){}

  @HostListener('click') onClick() {
    this.isChecked = this.el.nativeElement.getAttribute('ischecked');

    if (this.isChecked == 'no'){
      this.renderer.setAttribute(this.el.nativeElement, 'ischecked', 'yes');
    }else{
      this.ingridentArray['pid'] = this.el.nativeElement.getAttribute('pid');
      this.ingridentArray['gradeName'] = this.el.nativeElement.getAttribute('gradeName');
      this.ingridentArray['gradeid'] = this.el.nativeElement.getAttribute('gradeid');
      this.ingridentArray['ingvalue'] = this.el.nativeElement.getAttribute('value');

      this.prodObj.ingrdAr.emit(this.ingridentArray); //Emmiting id array to products service and then receiving in product detail component

      this.renderer.setProperty(this.el.nativeElement, 'checked', false);
      this.renderer.setAttribute(this.el.nativeElement, 'ischecked', 'no');
    }
  }


}
